export default __webpack_public_path__ + "static/media/aaseal.4bbc03aa.png";